export const RaleighLocation = {
  value: 'Raleigh',
  label: 'Raleigh, NC',
}
